<template>
  <component
    v-if="col.show === undefined || resolveFn(col.show, item, index)"
    :is="resolveFn(col.component, item, index)"
    v-bind="resolveFn(col.props, item, index)"
    v-on="resolveFn(col.events, item, index)"
  />
</template>
<script>
import BaseColumnRendererMixin from 'vue-cl/renderers/column/BaseColumnRendererMixin';

export default {
  mixins: [ BaseColumnRendererMixin ]
};
</script>
